import React from 'react';

// Sentry の FallbackProps の型定義
interface FallbackProps {
  error: Error | null;
  resetError?: () => void;
}

export const ErrorFallback: React.FC<FallbackProps> = ({
  error,
  resetError,
}) => {
  return (
    <div
      style={{
        padding: '20px',
        margin: '20px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '8px',
        textAlign: 'center',
        maxWidth: '600px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <h3 style={{ color: '#343a40', marginBottom: '16px' }}>
        問題が発生しました
      </h3>

      <p style={{ color: '#495057', marginBottom: '16px' }}>
        申し訳ありませんが、アプリケーションの一部で問題が発生しました。
        すでにエラーは自動的に報告され、対応いたします。
      </p>

      {resetError && (
        <button
          onClick={resetError}
          style={{
            backgroundColor: '#0086BF',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 16px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          再試行する
        </button>
      )}

      <p style={{ color: '#6c757d', fontSize: '14px', marginTop: '16px' }}>
        問題が解決しない場合は、ページをリロードするか、サポートにお問い合わせください。
      </p>

      {process.env.NODE_ENV !== 'production' && (
        <details style={{ marginTop: '20px', textAlign: 'left' }}>
          <summary style={{ cursor: 'pointer', color: '#6c757d' }}>
            エラーの詳細（開発環境のみ）
          </summary>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              backgroundColor: '#f1f3f5',
              padding: '12px',
              borderRadius: '4px',
              color: '#e03131',
              marginTop: '8px',
              fontSize: '12px',
              overflow: 'auto',
            }}
          >
            {error?.message || 'Unknown error'}
          </pre>
        </details>
      )}
    </div>
  );
};
